import axios from 'axios'
import {
  ProfileModel,
  ResponseCRUD,
  ResponseMenuProfile,
  ResponseObject,
  ResponseObjectPaginated,
} from '../model'

const BASEURL = process.env.REACT_APP_DEV_API_CENTRAL_URL
export function getProfile(dto: ProfileModel, page: number, size: number = 10) {
  return axios.post<ResponseObjectPaginated<ProfileModel[]>>(
    `${BASEURL}/profile/getAll/${page}?size=${size}`,
    dto,
  )
}

export function getProfileById(dto: any) {
  return axios.get<ResponseObject<ProfileModel>>(
    `${BASEURL}/profile/getInformationById?profileId=${encodeURIComponent(dto)}`,
  )
}

export function createProfile(dto: ProfileModel) {
  return axios.post<ResponseCRUD>(`${BASEURL}/profile/createProfile`, dto)
}

export function deleteProfile(dto: any) {
  return axios.delete<ResponseCRUD>(`${BASEURL}/profile/deleteProfile?id=${dto}`)
}

export function updateProfile(dto: ProfileModel) {
  return axios.put<ResponseCRUD>(`${BASEURL}/profile/updateProfile`, dto)
}

// OPTIONS

export function getOptionsByProfile(page: number, id: any) {
  return axios.post<ResponseObjectPaginated<ProfileModel[]>>(
    `${BASEURL}/profile/getAllOptionsByProfileNew/${page}?perfilId=${id}`,
    {},
  )
}

export function assignOptionsByProfile(dto: any, vistaPermisoId: string, perfilId: string) {
  return axios.post<ResponseCRUD>(
    `${BASEURL}/profile/assignPermissionsOptionsProfile?vistaPermisoId=${vistaPermisoId}&perfilId=${perfilId}`,
    dto,
  )
}

export function editNewOptionsByProfile(dto: any, vistaPermisoId: string, perfilId: string) {
  return axios.post<ResponseCRUD>(
    `${BASEURL}/profile/editAssignPermissionsOptionsProfile?vistaPermisoId=${vistaPermisoId}&perfilId=${perfilId}`,
    dto,
  )
}

export function saveOptionsByProfile(dto: any) {
  return axios.post<ResponseCRUD>(`${BASEURL}/profile/assingViewsToProfile`, dto)
}
export function editOptionsByProfile(dto: any) {
  return axios.post<ResponseCRUD>(`${BASEURL}/profile/editViewProfile`, dto)
}
export function deleteOptionsByProfile(dto: any) {
  return axios.post<ResponseCRUD>(`${BASEURL}/profile/deleteViewsToProfile`, dto)
}

// MENU

export function getMenuByProfile(appId: string) {
  return axios.get<ResponseMenuProfile>(`${BASEURL}/profile/getMenuByProfile`, {
    params: {aplicacionId: appId},
  })
}
